import { useTranslation } from '@fanfanlo'
import { IActionScriptData } from './IActionScript.inft'
import { scriptActionSimpleTemplate, scriptActionAdvancedTemplate, scriptActionFullTemplate } from '../scriptTemplates'
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material'
import { useState } from 'react'

type ScriptMode = 'simple' | 'advanced' | 'full'

/**
 * ActionScript UI 组件
 * 脚本动作编辑器
 */
export function IActionScriptUI(data: IActionScriptData) {
    const { t } = useTranslation('droid-project-v2-ext/actions/script/script-action/content')

    const [mode, setMode] = useState<ScriptMode>(data.javaData.scriptMode || 'simple')
    const [code, setCode] = useState(data.javaData.script || scriptActionSimpleTemplate)

    function handleModeChange(newMode: ScriptMode) {
        setMode(newMode)
        data.javaData.scriptMode = newMode

        let template = scriptActionSimpleTemplate
        if (newMode === 'advanced') {
            template = scriptActionAdvancedTemplate
        } else if (newMode === 'full') {
            template = scriptActionFullTemplate
        }
        setCode(template)
        data.javaData.script = template
    }

    function handleCodeChange(newCode: string) {
        setCode(newCode)
        data.javaData.script = newCode
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2 }}>
                <Typography variant="h6" component="b">
                    {t('IActionScript.title')}
                </Typography>
            </Box>

            <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>{t('IActionScript.scriptMode')}</InputLabel>
                <Select
                    data-testid="ActionScriptUI__modeSelect__01JFXYZG8W2X3Y4Z5A6B7C8D9"
                    value={mode}
                    label={t('IActionScript.scriptMode')}
                    onChange={(e) => handleModeChange(e.target.value as ScriptMode)}
                >
                    <MenuItem value="simple">{t('IActionScript.scriptMode_simple')}</MenuItem>
                    <MenuItem value="advanced">{t('IActionScript.scriptMode_advanced')}</MenuItem>
                    <MenuItem value="full">{t('IActionScript.scriptMode_full')}</MenuItem>
                </Select>
            </FormControl>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {mode === 'simple' && t('IActionScript.modeDescription_simple')}
                {mode === 'advanced' && t('IActionScript.modeDescription_advanced')}
                {mode === 'full' && t('IActionScript.modeDescription_full')}
            </Typography>

            <TextField
                data-testid="ActionScriptUI__codeEditor__01JFXYZH9X3Y4Z5A6B7C8D9E0"
                fullWidth
                multiline
                rows={12}
                label={t('IActionScript.scriptCode')}
                value={code}
                onChange={(e) => handleCodeChange(e.target.value)}
                placeholder={t('IActionScript.scriptPlaceholder')}
                sx={{ fontFamily: 'monospace' }}
            />
        </Box>
    )
}
